/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources/:source_id/refresh_schemas" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiSourcesSourceIdRefreshSchemasCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiSourcesSourceIdRefreshSchemasProps,
  PostIntegrationsDirectCdiSourcesSourceIdRefreshSchemasResult,
} from "./types";

export const postIntegrationsDirectCdiSourcesSourceIdRefreshSchemas = reactQueryMutationAdapter(
  postIntegrationsDirectCdiSourcesSourceIdRefreshSchemasCacheKeys,
  (
    props: PostIntegrationsDirectCdiSourcesSourceIdRefreshSchemasProps
  ): Promise<PostIntegrationsDirectCdiSourcesSourceIdRefreshSchemasResult> => {
    const { sourceId } = props;
    return fetch(`/integrations/direct/cdi/sources/${sourceId}/refresh_schemas`, "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
